module.exports = __webpack_public_path__ + "static/media/audio-btn-download.1ac760be.svg";